import React from 'react';
import PropTypes from 'prop-types';
import {Box, Heading, List, ListItem} from '@spothero/ui';
import {leftColumnItemStyleProps} from 'pages/parking-pass/styles';

const ThingsYouShouldKnow = ({restrictions}) => {
    if (!restrictions || !restrictions.length) {
        return null;
    }

    return (
        <Box {...leftColumnItemStyleProps}>
            <Heading as="h2" marginBottom={3}>
                Things You Should Know
            </Heading>
            <List>
                {restrictions.map(restriction => (
                    <ListItem
                        borderBottomWidth="1px"
                        _last={{
                            borderBottomWidth: 0,
                            paddingBottom: 0,
                        }}
                        _first={{
                            paddingTop: 0,
                        }}
                        borderBottomColor="gray.100"
                        paddingY={4}
                        marginBottom={0}
                        key={restriction}
                    >
                        <Box
                            as="span"
                            lineHeight="1.4"
                            fontSize="base"
                            // Text that mentions VIP Event Parking should be in red
                            color={
                                restriction.includes('VIP') ? 'error' : 'black'
                            }
                            dangerouslySetInnerHTML={{__html: restriction}}
                        />
                    </ListItem>
                ))}
            </List>
        </Box>
    );
};

ThingsYouShouldKnow.propTypes = {
    restrictions: PropTypes.arrayOf(PropTypes.string),
};

export default ThingsYouShouldKnow;
